export default "__VITE_ASSET__BeAeOG2a__"